import { render, staticRenderFns } from "./AddDiscoveryCampaignCityAndPriceSetting.vue?vue&type=template&id=08f47625"
import script from "./AddDiscoveryCampaignCityAndPriceSetting.vue?vue&type=script&lang=js"
export * from "./AddDiscoveryCampaignCityAndPriceSetting.vue?vue&type=script&lang=js"
import style0 from "./AddDiscoveryCampaignCityAndPriceSetting.vue?vue&type=style&index=0&id=08f47625&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports